import {
  SET_ACCESS_ROLE,
  SET_ACCESS_ACTIVE_ROLE,
  SET_ACCESS_ACTIVE_ROLE_CHECKED,
  SET_ROLE_NAME,
  SET_ROLE_INVITES,
  SET_ROLE_ID,
} from '../types';

const initialState = {
  role: [],
  active: {},
  name: '',
  invites: [],
  role_id: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCESS_ROLE:
      return {
        ...state,
        role: action.role,
      };
    case SET_ACCESS_ACTIVE_ROLE:
      return {
        ...state,
        active: action.payload,
      };
    case SET_ACCESS_ACTIVE_ROLE_CHECKED:
      return {
        ...state,
        active: action.payload,
      };
    case SET_ROLE_NAME:
      return {
        ...state,
        name: action.name,
      };
    case SET_ROLE_INVITES:
      return {
        ...state,
        invites: action.invites,
      };
    case SET_ROLE_ID:
      return {
        ...state,
        role_id: action.role_id,
      };
    default:
      return state;
  }
}
